import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  devices: [],
  sensorData: {},
  loading: false,
  error: null,
};

const deviceSlice = createSlice({
  name: 'devices',
  initialState,
  reducers: {
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setDevices: (state, action) => {
      state.devices = action.payload;
      state.loading = false;
    },
    addDevice: (state, action) => {
      state.devices.push(action.payload);
    },
    updateDevice: (state, action) => {
      const index = state.devices.findIndex(d => d.id === action.payload.id);
      if (index !== -1) {
        state.devices[index] = action.payload;
      }
    },
    setSensorData: (state, action) => {
      state.sensorData[action.payload.deviceId] = action.payload.data;
    },
    setError: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    updateGatewayStatus: (state, action) => {
      const { deviceId, status, lastSeen } = action.payload;
      const deviceIndex = state.devices.findIndex(d => d.id === deviceId);
      if (deviceIndex !== -1) {
        state.devices[deviceIndex] = {
          ...state.devices[deviceIndex],
          status,
          lastSeen
        };
      }
    },
    updateBeaconLocation: (state, action) => {
      const { beaconId, x, y, z, timestamp } = action.payload;
      const deviceIndex = state.devices.findIndex(d => d.id === beaconId || d.ble_id === beaconId);
      if (deviceIndex !== -1) {
        const now = Date.now();
        const locationTime = new Date(timestamp).getTime();
        
        state.devices[deviceIndex] = {
          ...state.devices[deviceIndex],
          location_coords: { x, y, z },
          lastLocationUpdate: timestamp,
          lastSeen: timestamp,
          status: (now - locationTime) <= 60000 ? 'online' : 'offline'
        };
      }
    },
  },
});

export const { setLoading, setDevices, addDevice, updateDevice, setSensorData, setError, updateGatewayStatus, updateBeaconLocation } = deviceSlice.actions;
export default deviceSlice.reducer;